import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { OnDestroyMixin, untilComponentDestroyed } from '@w11k/ngx-componentdestroyed';
import { PusherService } from 'app/core';
import { AuthService } from 'app/core/services/auth.service';
import { InformativeSignoutCodes } from 'app/shared/enums';
import { interval } from 'rxjs';
import { take } from 'rxjs/operators';

const INFORMATIVE_SIGNOUT_MESSAGES = {
  [InformativeSignoutCodes.NotAssociated]:
    'You are not associated with this account. Please contact your account admin.',
};

@Component({
  selector: 'auth-sign-out',
  templateUrl: './sign-out.component.html',
  styleUrls: ['./sign-out.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class AuthSignOutComponent extends OnDestroyMixin implements OnInit {
  countdown: number;
  countdownMapping: any;
  informativeMessage: string;

  /**
   * Constructor
   *
   * @param {AuthService} _authService
   * @param {Router} _router
   */
  constructor(
    private _authService: AuthService,
    private _pusherService: PusherService,
    private _router: Router,
    private activateRoute: ActivatedRoute,
  ) {
    super();
    // Set the defaults
    this.countdown = 5;
    this.countdownMapping = {
      '=1': '# second',
      other: '# seconds',
    };
  }

  // -----------------------------------------------------------------------------------------------------
  // @ Lifecycle hooks
  // -----------------------------------------------------------------------------------------------------

  /**
   * On init
   */
  ngOnInit(): void {
    this.activateRoute.queryParams.pipe(take(1)).subscribe((params) => {
      if (params.messageCode) {
        this.informativeMessage = INFORMATIVE_SIGNOUT_MESSAGES[params.messageCode];
      }
    });

    // Sign out
    this._authService.signOut();

    this._pusherService.deRegisterFromPusher();

    // Get the duration
    const duration = this.countdown;

    // Redirect after the countdown
    interval(1000)
      .pipe(take(duration), untilComponentDestroyed(this))
      .subscribe(
        () => {
          this.countdown--;
        },
        () => {},
        () => {
          this._router.navigate(['sign-in']);
        },
      );
  }
}
